import React, { FC } from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { hasPermission, selectOrganization } from "go-security/services/organizations/selectors";

interface Props {
	productId: string;
}

const SubmenuProductNavigation: FC<Props> = ({ productId }) => {
	const organization = useSelector(selectOrganization);
	const displayAppLinksNavItem = useSelector(hasPermission(["PRODUCT_LINKS", "SETTINGS"]));
	const { t } = useTranslation();

	const isTabActive = (tabName: string) => {
		switch (tabName) {
			case "transactions":
				return window.location.pathname.includes("transactions");
			case "documents":
				return window.location.pathname.includes("documents");
			case "app_links":
				return window.location.pathname.includes("app_links");
			case "contacts":
				return window.location.pathname.includes("contacts");
			case "default":
				return (
					!window.location.pathname.includes("transactions") &&
					!window.location.pathname.includes("documents") &&
					!window.location.pathname.includes("app_links") &&
					!window.location.pathname.includes("contacts")
				);
			default:
				return false;
		}
	};

	return (
		<div className="content-navigation">
			<Nav>
				<Nav.Item>
					<Nav.Link
						as={NavLink}
						to={`/${organization.id}/products/${productId}/edit`}
						isActive={() => isTabActive("default")}
					>
						{t("common.word.edition")}
					</Nav.Link>
				</Nav.Item>
				{/* <Nav.Item>
					<Nav.Link
						as={NavLink}
						to={`/${organization.id}/products/${productId}/edit/transactions`}
						isActive={() => isTabActive("transactions")}
					>
						{t("common.word.transactions")}
					</Nav.Link>
				</Nav.Item> */}
				<Nav.Item>
					<Nav.Link
						as={NavLink}
						to={`/${organization.id}/products/${productId}/edit/documents`}
						isActive={() => isTabActive("documents")}
					>
						{t("components.navigation.documents.title")}
					</Nav.Link>
				</Nav.Item>
				{displayAppLinksNavItem && (
					<Nav.Item>
						<Nav.Link
							as={NavLink}
							to={`/${organization.id}/products/${productId}/edit/app_links`}
							isActive={() => isTabActive("app_links")}
						>
							{t("components.navigation.app_links.title")}
						</Nav.Link>
					</Nav.Item>
				)}
				<Nav.Item>
					<Nav.Link
						as={NavLink}
						to={`/${organization.id}/products/${productId}/edit/contacts`}
						isActive={() => isTabActive("contacts")}
					>
						{t("modules.contact.header.title")}
					</Nav.Link>
				</Nav.Item>
			</Nav>
		</div>
	);
};

export default SubmenuProductNavigation;
